import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthHeader } from '../_models/headers';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';

@Injectable({
  providedIn: 'root'
})
export class DrillSkillService {
  aHeader = undefined
  headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  options = { headers: this.headers }
  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService) { this.aHeader = new AuthHeader(tss)}

    getDrillSkills() {
      return this.http.get<any>(`${environment.apiUrl}/drillSkill/listAll`,this.aHeader.bearerJsonHeaders).pipe(map(
        data=>{
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }
        }
      ))
    }
    getDrillSkillItem(id:number) {
      return this.http.get<any>(`${environment.apiUrl}/drillSkill/apishow/${id}`,this.aHeader.bearerJsonHeaders).pipe(map(
        data=>{
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }
        }
      ))
    }
    newDrillSkillItem(formData:string){
      return this.http.post(`${environment.apiUrl}/drillSkill/addDrillSkill`, formData, this.aHeader.bearerFormHeaders)
        .pipe(map(data => {
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }

        }));
    }
  }
